import { isReadOnlySelector } from 'modules/MedComms/selectors';
import { createStructuredSelector } from 'reselect';
import { activeLayer } from 'containers/Project/selectors';

export const columnSelector = createStructuredSelector({
  activeLayer,
  isReadOnly: isReadOnlySelector,
});
